import showdown from "showdown";

const converter = new showdown.Converter();

export const makeHtml = (content: string) => {
  const kwContent = content.replace(
    /\u200b(.*?)\u200b/g,
    '<span class="kw" style="background-color: #f0f; color: #fff; padding: 0 5px; border-radius: 5px;">$1</span>',
  );
  return converter.makeHtml(kwContent);
};
